export default {
  buttonCalculate: 'Tính toán',

  method: 'Phương pháp',

  resultTitle: 'Kết Quả',

  popupPE: {
    title: 'Doanh nghiệp cùng ngành',
    button: 'HOÀN THÀNH',
    selectAll: 'CHỌN TOÀN BỘ',
    totalAsset: 'TỔNG TÀI SẢN',
    rev: 'D.THU',
    netProfit: 'LÃI THUẦN',
    marketCap: 'VỐN HÓA',
    pe: 'P/E',
    pb: 'P/B',
    averagePE: 'P/E T.Bình',
    averagePB: 'P/B T.Bình',
  },

  popupFCFE: {
    title: 'ƯỚC LƯỢNG',
    button: 'HOÀN THÀNH',
    riskFreeRate: 'Lãi suất phi rủi ro',
    vnIndexERP: 'Phần bù rủi ro VNINDEX',
    equityBOS: 'Hệ số Beta',
    estimatedCOE: 'Chi phí Vốn CSH (Ước lượng)',
    otherAdjustment: 'Điều chỉnh khác',
    costOfEquity: 'Chi phí Vốn CSH',
    riskFreeRateNote: 'Lãi suất Trái phiếu Chính Phủ VN 10 năm',
    vnIndexErpNote: 'Lợi tức kỳ vọng - Lãi suất phi rủi ro',
    estimatedCoeNote: 'Lãi suất phi rủi ro + Beta*Phần bù rủi ro',
  },

  methodFCFE: {
    numOneFirst: '1 / Dòng tiền thuần vốn CSH (FCFE)',
    numOneLast: 'Tỷ VND',
    numTwoFirst: '2 / Tăng trưởng dòng tiền FCFE: g1',
    numTwoMid: '% trong',
    numTwoLast: 'năm',
    numThreeFirst: '3 / Tăng trưởng dòng tiền FCFE: g2',
    numThreeLast: '% trong giai đoạn ổn định',
    numFour: '4 / Chi phí vốn CSH',
  },

  resultFCFE: {
    numOneFirst: 'Giá cổ phiếu (Ước tính)',
    numOneLast: 'VND/Cổ phiếu',
  },

  methodPE: {
    numOneFirst: '1 / EPS hiện tại của doanh nghiệp',
    numOneLast: 'VND/Cổ phiếu',
    numTwoFirst: '2 / EPS ước tính(EOY)',
    numbTwoLast: 'VND/Cổ phiếu',
    numThreeFirst: '3 / EPS dự phóng(Năm Tới)',
    numbThreeLast: 'VND/Cổ phiếu',
    numFour: '4 / Hệ số nhân P/E',
  },

  resultPE: {
    numOneFirst: 'Giá cổ phiếu cuối năm nay',
    numOneLast: 'VND/Cổ phiếu',
    numTwoFirst: 'Giá cổ phiếu cuối năm sau',
    numTwoLast: 'VND/Cổ phiếu',
  },

  methodPB: {
    numOne: '1 / Giá trị sổ sách hiện tại',
    numOneLast: 'VND/Cổ phiếu',
    numTwoFirst: '2 / Giá trị sổ sách ước tính(EOY)',
    numTwoLast: 'VND/Cổ phiếu',
    numThreeFirst: '3 / Giá trị sổ sách dự phóng(Năm tới)',
    numThreeLast: 'VND/Cổ phiếu',
    numFour: '4 / Hệ số nhân P/B',
  },

  resultPB: {
    numOneFirst: 'Giá cổ phiếu cuối năm nay',
    numOneLast: 'VND/Cổ phiếu',
    numTwoFirst: 'Giá cổ phiếu cuối năm sau',
    numTwoLast: 'VND/Cổ phiếu',
  },

  errorFCFE: {
    g1Error: 'Hệ thống không thể tính toán! Hãy kiểm tra lại tỷ lệ tăng trưởng',
    g2Error:
      'Hệ thống không thể tính toán! Hãy kiểm tra lại tỷ lệ tăng trưởng ổn định g2',
    g2ErrorSameNumber: 'Lỗi! Giá trị của g2 không thể bằng chi phí vốn CSH',
    costOfEquityError:
      'Hệ thống không thể tính toán! Hãy kiểm tra chi phí vốn CSH',
    currentFreeCte: `Hệ thống không thể tính toán do thiếu dữ liệu của dòng tiền thuần vốn CSH `,
  },

  errorPE: {
    estimatedEOYError:
      'Hệ thống không thể tính toán! Hãy kiểm tra EPS ước tính (EOY)',
    epsForecastError:
      'Hệ thống không thể tính toán! Hãy kiểm tra EPS dự phóng (Năm tới)',
    peMultipleError:
      'Hệ thống không thể tính toán! Hãy kiểm tra hệ số nhân P/E',
  },

  errorPB: {
    estimateBookValuedEOYError:
      'Hệ thống không thể tính toán! Hãy kiểm tra giá trị sổ sách ước tính (EOY)',
    bookValueForecastError:
      'Hệ thống không thể tính toán! Hãy kiểm tra giá trị sổ sách dự phóng (Năm tới)',
    pbMultiple: 'Hệ thống không thể tính toán! Hãy kiểm tra hệ số nhân P/B',
  },

  tooltipInfo: {
    fcfe: `FCFE cho biết số tiền mà doanh nghiệp có thể mang lại cho chủ sở hữu`,
    pe: `Tỷ số P/E so sánh thị giá của công ty với lợi nhuận trên một cổ phiếu của công ty đó`,
    pb: `Tỷ số P/B so sánh thị giá của công ty với giá trị sổ sách của công ty đó`,
  },
  button: {
    recommend: 'Khuyến Nghị',
  },
  Onlyinputnumber: 'Chỉ nhập số',
};
